// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2OXy3","footerContent":"Footer_footerContent__1HO9u","footerLogo":"Footer_footerLogo__1tYhZ"};